<nav class="navbar navbar-dark flex-down mt-2">
  <ul class="list-horizontal text-white float-start roboto-font">
    <li *ngFor="let tab of tabs; let i = index" [ngClass]="{ active: activeTabId === i }" (click)="changeTab(i)">{{ tab }}</li>
  </ul>
</nav>
